import React from 'react';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import PermissionsEditor from '@/components/permissions/PermissionsEditor';
import { useAsyncState } from '@/utils/hooks';
import { ProfileMemberPermissions, ProfilePermissionType } from '@/types';
import { getProfilePermissions } from '@/services/profiles';
import { Trans } from '@lingui/react/macro';
import { AlertBanner, Radio, RadioGroup } from '@ygtechnologies/rubus-ui';

interface OwnProps {
    value: ProfileMemberPermissions;
    onChange(newValue: ProfileMemberPermissions): void;
}

const ProfilePermissionsEditor: React.FC<OwnProps> = ({ value, onChange }) => {
    const [permissions] = useAsyncState(() => getProfilePermissions(), [], null);
    function triggerChange(obj: Partial<ProfileMemberPermissions>) {
        const newValue = {
            ...value,
            ...obj,
        };

        triggerHandler(onChange, newValue);
    }

    const handleProjectPermissionChange = (profilePermissions) => {
        triggerChange({ profilePermissions });
    };

    if (!permissions) {
        return null;
    }

    return (
        <div>
            <h4>
                <Trans>User type</Trans>
            </h4>
            <RadioGroup orientation="vertical">
                <Radio
                    onChange={(e) => triggerChange({ isAdministrator: true })}
                    checked={value.isAdministrator}
                    inputSize="md">
                    <Trans>Admin</Trans>
                </Radio>
                <Radio
                    onChange={(e) => triggerChange({ isAdministrator: false })}
                    checked={!value.isAdministrator}
                    inputSize="md">
                    <Trans>Member</Trans>
                </Radio>
            </RadioGroup>
            {value.isAdministrator && (
                <AlertBanner type="warning">
                    <Trans>
                        Making a user an admin on this profile would provide the user access to the project dashboard in all
                        projects created by anyone in this company profile.
                    </Trans>
                </AlertBanner>
            )}

            <hr />
            <PermissionsEditor<ProfilePermissionType>
                isAdministrator={value.isAdministrator}
                permissions={permissions}
                value={value.profilePermissions || []}
                onChange={handleProjectPermissionChange}
            />
        </div>
    );
};

export default ProfilePermissionsEditor;
